import React, { useEffect, useRef, useState } from "react";
import "./TypeFilteredDropdown.css";

export default function TypeFilteredDropdown({
  items = [],
  types = [],
  selectedId = "",
  selectedLabel = "Select an item",
  emptyLabel = "No items match the selected types.",
  groupLabel = "Items",
  onSelect,
  disabled = false,
}) {
  const [hiddenTypes, setHiddenTypes] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (!dropdownRef.current?.contains(event.target)) dropdownRef.current?.removeAttribute("open");
    };
    document.addEventListener("pointerdown", closeOnOutsideClick);
    return () => document.removeEventListener("pointerdown", closeOnOutsideClick);
  }, []);

  const visibleItems = items.filter((item) =>
    !hiddenTypes.includes(item.type) || String(item.id) === String(selectedId)
  );

  return (
    <details
      className="mb-typeDropdown"
      ref={dropdownRef}
      onKeyDown={(event) => {
        if (event.key === "Escape") {
          dropdownRef.current?.removeAttribute("open");
          dropdownRef.current?.querySelector("summary")?.focus();
        }
      }}
    >
      <summary className="mb-typeDropdown-summary"><span>{selectedLabel}</span></summary>
      <div className="mb-typeDropdown-panel">
        <div className="mb-typeDropdown-filters" role="group" aria-label={`Show ${groupLabel.toLowerCase()} types`}>
          <span className="mb-typeDropdown-filterTitle">Show types</span>
          <div className="mb-typeDropdown-filterOptions">
            {types.map(({ value, label }) => (
              <label className="mb-typeDropdown-typeCheck" key={value}>
                <input
                  type="checkbox"
                  checked={!hiddenTypes.includes(value)}
                  onChange={(event) => setHiddenTypes((current) =>
                    event.target.checked
                      ? current.filter((type) => type !== value)
                      : [...current, value]
                  )}
                  disabled={disabled}
                />
                {label}
              </label>
            ))}
            <button
              className="mb-typeDropdown-clear"
              type="button"
              onClick={() => setHiddenTypes(types.map(({ value }) => value))}
              disabled={disabled || types.every(({ value }) => hiddenTypes.includes(value))}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="mb-typeDropdown-options" role="group" aria-label={groupLabel}>
          {visibleItems.map((item) => (
            <button
              className={`mb-typeDropdown-option${String(item.id) === String(selectedId) ? " isSelected" : ""}`}
              key={item.id}
              type="button"
              onClick={() => {
                onSelect?.(item.id);
                dropdownRef.current?.removeAttribute("open");
              }}
              disabled={disabled}
            >
              {hiddenTypes.includes(item.type) && String(item.id) === String(selectedId) ? "Current: " : ""}
              {item.label}
            </button>
          ))}
          {!visibleItems.length && <div className="mb-typeDropdown-empty">{emptyLabel}</div>}
        </div>
      </div>
    </details>
  );
}
